import Service, { service } from '@ember/service';
import { task, all } from 'ember-concurrency';
import { waitFor } from '@ember/test-waiters';
import { isTesting, macroCondition } from '@embroider/macros';

export default class DataPreloader extends Service {
  @service currentUser;
  @service store;
  @service session;

  loadCurrentUserAndData = task(waitFor(async () => {
    if (!this.session.isAuthenticated) {
      return;
    }

    const spinner = this.#addBodySpinner();

    const store = this.store;
    try {
      await all([
        store.findAll('license'),
        store.findAll('legacy-license'),
        store.findAll('organization'),
        store.findAll('user'),
      ]);

      await this.currentUser.setupUser.perform();

      if (!this.session.isOidc) {
        this.session.isActuallyAuthenticated = true;
      }
    } catch (error) {
      console.error(error);
      await this.session.invalidate();
    } finally {
      spinner?.remove();
    }
  }));

  #addBodySpinner() {
    if (macroCondition(isTesting())) {
      return;
    }

    const spinner = document.createElement('div');
    spinner.classList.add(
      'spinner-overlay', 'h2', 'vh-100', 'd-flex', 'flex-column', 'align-items-center', 'justify-content-center',
    );

    spinner.innerHTML = `
      <div class="spinner spinner-border text-secondary" role="status"></div>
    `;

    document.body.prepend(spinner);
    return spinner;
  }
}
